module.exports = __webpack_public_path__ + "img/OurJourney2021.7b397e37.png";